import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { BaseUserEntity, UserKind } from '@resident-select/domain/core';

export interface UserKindDialogData {
  users: Array<{ user: BaseUserEntity; userKind: UserKind }>;
  authId: string;
}

export interface UserKindDialogResult {
  userKind: UserKind;
  authId: string;
}

const USER_KIND_LABELS: Record<UserKind, string> = {
  resident: 'Residente',
  vendor: 'Proveedor',
  doorman: 'Portero',
  superAdmin: 'Super Administrador',
  agencyAdmin: 'Administrador de Inmobiliaria',
  user: 'Colaborador',
};

@Component({
  selector: 'app-user-kind-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatListModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Seleccionar tipo de usuario</h2>
    <mat-dialog-content>
      <mat-selection-list [multiple]="false">
        @for (item of data.users; track item.userKind) {
          <mat-list-option (click)="select(item.userKind)">
            {{ getUserKindLabel(item.userKind) }}
          </mat-list-option>
        }
      </mat-selection-list>
    </mat-dialog-content>
  `,
})
export class UserKindDialog {
  constructor(
    private readonly dialogRef: MatDialogRef<UserKindDialog, UserKindDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: UserKindDialogData,
  ) {}

  getUserKindLabel(userKind: UserKind): string {
    return USER_KIND_LABELS[userKind] || userKind;
  }

  select(userKind: UserKind): void {
    this.dialogRef.close({ userKind, authId: this.data.authId });
  }
}
